export default __webpack_public_path__ + "static/media/bnb.6fb9c615.svg";